import { useCallback, useRef, useState, startTransition } from 'react'

import { newHomepageService } from 'Pods/NewHomepage/Services/newHomepageService'

// Fetches the trending models once, when the section asks for them (it does so from its
// own IntersectionObserver). The list lands in a transition so a tap or scroll that arrives
// while React renders the eight cards is handled first.
const useTrendingModels = ({ perPage = 8 } = {}) => {
  const [trendingModels, setTrendingModels] = useState([])
  const requestedRef = useRef(false)

  const loadTrendingModels = useCallback(() => {
    if (requestedRef.current) {
      return
    }

    requestedRef.current = true

    newHomepageService.getTrendingModels(perPage)
      .then((data) => {
        startTransition(() => {
          setTrendingModels(data)
        })
      })
      .catch(() => {
        // Already reported by the service; allow a later intersection to retry.
        requestedRef.current = false
      })
  }, [perPage])

  return {
    trendingModels,
    loadTrendingModels,
  }
}

export default useTrendingModels
